<template lang='pug'>
div
    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title UHF PD Sensors
            //- h2.notopmargin BSS offers a range of sensors suitable for measurements of partial discharges in transformers in the ultra-high frequency range, for installation into new transformers or for retrofits.

        router-link.section(to="/en/products/uhfsensors/uhf-ps1")
            .column-container
                .column.flexgrow
                    .producttitle UHF-PS1
                    .subtitle Window-Type UHF PD Sensor 
                    ul
                        li For integration into the tank wall of new transformers
                        li Design of dielectric window and sensor according to Cigré TB662
               
                .column.alignright
                    picture.overview-product-picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/UHF-PS1.webp')
                        img( src='@/assets/photos/product_shots/UHF-PS1.png', width="100%", alt='Window-Type UHF PD Sensor UHF-PS1', title='Window-Type UHF PD Sensor UHF-PS1')

        router-link.section(to="/en/products/uhfsensors/uhf-dvs-50")
            .column-container
                .column.flexgrow
                    .producttitle UHF-DVS-50
                    .subtitle Drain Valve UHF PD Sensor for Retrofit at Power Transformers
                    ul
                        li Installation at DN50 and DN80 oil valves
                        li Insertion depth max. 410 mm
                .column.alignright
                    picture.overview-product-picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/UHF-DVS-50.webp')
                        img( src='@/assets/photos/product_shots/UHF-DVS-50.png', width="100%", alt='UHF PD Sensor UHF-DVS-50', title='UHF PD Sensor UHF-DVS-50')

        router-link.section(to="/en/products/uhfsensors/uhf-dvs-25")
            .column-container
                .column.flexgrow
                    .producttitle UHF-DVS-25
                    .subtitle Drain Valve UHF PD Sensor for Retrofit at Transformers with Small Oil Valves
                    ul
                        li Installation at DN25 and DN40 oil valves
                        li Insertion depth max. 300 mm
                .column.alignright
                    picture.overview-product-picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-DVS-25.webp')
                        img( src='@/assets/photos/UHF-DVS-25.png', width="100%", alt='UHF PD Sensor UHF-DVS-25', title='UHF PD Sensor UHF-DVS-25')

        router-link.section(to="/en/products/uhfsensors/uhf-ls-50")
            .column-container
                .column.flexgrow
                    .producttitle UHF-LS-50
                    .subtitle Standpipe UHF PD Sensor 
                    ul
                        li Installation at distribution-level transformers using level-switch standpipes
                        li Various types available
                .column.alignright
                    picture.overview-product-picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-LS-50.webp')
                        img( src='@/assets/photos/UHF-LS-50.png', width="100%", alt='UHF PD Sensor UHF-LS-50', title='UHF PD Sensor UHF-LS-50')


    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title UHF-Teilentladungssensoren
            //- h2.notopmargin Die UHF-TE-Sensoren der BSS sind für die Installation bei neuen Transformatoren sowie die nachträgliche Installation bei existierenden Transformatoren geeignet. Alle Sensoren sind mit dem #[router-link.ul(to="/products/pdm600") UHF-TE-Monitoringsystem PDM-600] kompatibel.

        router-link.section(to="/de/products/uhfsensors/uhf-ps1")
            .column-container
                .column.flexgrow
                    .producttitle UHF-PS1
                    .subtitle UHF-TE-Fenstersensor
                    ul
                        li Für die direkte Integration in neue Transformatoren
                        li Design von dielektrischem Fenster und Sensor gemäß Cigré TB662
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/UHF-PS1.webp')
                        img( src='@/assets/photos/product_shots/UHF-PS1.png', width="100%", alt='UHF-PS1 UHF-TE-Fenstersensor', title='UHF-PS1 UHF-TE-Fenstersensor')

        router-link.section(to="/de/products/uhfsensors/uhf-dvs-50", alt='UHF-TE-Sensor UHF-DVS-50', title='UHF-TE-Sensor UHF-DVS-50')
            .column-container
                .column.flexgrow
                    .producttitle UHF-DVS-50
                    .subtitle UHF-TE-Schiebesensor für die Nachrüstung an Leistungstransformatoren
                    ul
                        li Installation an DN50 und DN80 Ölschiebern im Betrieb möglich
                        li Einschubtiefe max. 410 mm
                .column.alignright
                    picture.overview-product-picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/UHF-DVS-50.webp')
                        img( src='@/assets/photos/product_shots/UHF-DVS-50.png', width="100%")

        router-link.section(to="/de/products/uhfsensors/uhf-dvs-25", alt='UHF-TE-Sensor UHF-DVS-25', title='UHF-TE-Sensor UHF-DVS-25')
            .column-container
                .column.flexgrow
                    .producttitle UHF-DVS-25
                    .subtitle UHF-TE-Schiebesensor für die Installation an kleinen Ölschiebern
                    ul
                        li Installation an DN25 und DN40 Ölschiebern im Betrieb möglich
                        li Einschubtiefe  max. 300 mm
                .column.alignright
                    picture.overview-product-picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-DVS-25.webp')
                        img( src='@/assets/photos/UHF-DVS-25.png', width="100%")

        router-link.section(to="/de/products/uhfsensors/uhf-ls-50", alt='UHF-TE-Sensor UHF-LS-50', title='UHF-TE-Sensor UHF-LS-50')
            .column-container
                .column.flexgrow
                    .producttitle UHF-LS-50
                    .subtitle UHF-TE-Standrohrsensor 
                    ul
                        li Installation an Verteiltransformatoren über typische Standrohre für Level-Schalter
                        li Verschiedene Ausführungen verfügbar
                .column.alignright
                    picture.overview-product-picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-LS-50.webp')
                        img( src='@/assets/photos/UHF-LS-50.png', style='height: 100', alt='UHF-TE-Sensor UHF-LS-50', title='UHF-TE-Sensor UHF-LS-50')
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | UHF-TE-Sensoren",
            description:
                "UHF-Teilentladungs(TE)-Sensoren für Transformatoren",
        },
        en: {
            title: "BSS | UHF PD Sensors",
            description:
                "UHF Partial Discharge(PD) Sensors for Transformers",
        },
    },
};
</script>

<style lang='sass' scoped>
@import '@/assets/sass/product_overview.sass'
</style>